/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useRef } from 'react'
import { message, } from 'antd'
import Sortable from '@shopify/draggable/lib/es5/sortable'
import Icon from 'meinian-package/src/component/icon'
import classnames from 'classnames'
import request from 'meinian-package/src/utils/request'
import link from 'meinian-package/src/utils/link'
import './upgradeModal.less'
import './upgrade.common.less'
import { ossImg } from 'meinian-package/src/utils/image'
import { Image } from './imageGalleryModal/simpleImage'
import GalleryModal from './imageGalleryModal/galleryModal'

const MAX_SELECT_COUNT = 20

let uploadCount = 0

export function AddBox({ title, onClick, className }) {
  return <div className={classnames('add-box', className)} onClick={onClick}>
    <Icon type="m-tianjia" />
    <span>{title}</span>
  </div>
}
export function AddGoods({ title, onClick }) {
  return <div className="add-goods">
    <span onClick={onClick}>{title}</span>
    <span>最多可添加五个关联商品</span>
  </div>
}
export function DeleteButton(props) {
  return <a className="delete" {...props}><Icon type={props.iconType} /></a>
}
export function SetMainImg(props) {
  return <a className="main-image" {...props}> 设为主图</a>
}
export function MainTag() {
  return <a className="main-tag">主图</a>
}
export function InputSearch({ value, onChange, placeholder }) {
  return <div className="ins-input-search">
    <input value={value} placeholder={placeholder} onInput={onChange} />
    <Icon type="m-sousuo" />
  </div>
}

export function useUpgradeInfo(inspirationId, entityId) {
  const [data, setData] = useState({ goods: null })
  const [loading, setLoading] = useState(false)
  const fetchData = async () => {
    try {
      if (!inspirationId || !entityId) return
      setLoading(true)
      const res = await request.sget('/zhikuan/image-bus/get-style-detail', { inspirationId, entityId }, 'MN_fetchImageUpgradeInfo')
      delete res?.platformId
      const itemInfoDTOList = res?.itemInfoDTOList
      const goodList = []
      if (itemInfoDTOList?.length > 0) {
        for (let i = 0; i < itemInfoDTOList.length; i++) {
          goodList.push({
            itemId: res?.itemIdList[i],
            title: itemInfoDTOList[i].itemTitle,
            cprice: itemInfoDTOList[i].price,
            picUrl: itemInfoDTOList[i].mainUrl,
            sale30day: itemInfoDTOList[i].saleMonthly,
            ...itemInfoDTOList[i]
          })
        }
      }
      setData({
        ...res,
        goods: goodList?.length > 0 ? goodList : null
      })
      setLoading(false)
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    fetchData()
  }, [inspirationId, entityId])
  return [data, setData, fetchData, loading]
}

export function GoodsInfo({ data, onClick, imgSlot, size, deleteSlot }) {
  const { title, cprice, itemId, sale30day, collect, commentCount, shopId, shopName, picUrl, itemName, price, salesVolume30 } = data || {}
  const label = (_title, value) => {
    return <span className="label">{_title}<label>{value}</label></span>
  }
  const events = {
    onJumpShop(_shopId, e) {
      e.stopPropagation()
      link.toShopDetail(_shopId)
    },
    onJumpItem(_itemId, e) {
      e.stopPropagation()
      link.toGoodDetail(_itemId)
    }
  }
  return <div className={classnames('meinian-upgrade-goods-info-row', size)} onClick={onClick}>
    <div className={classnames('img')} style={{ backgroundImage: `url(${picUrl})` }}>
      {imgSlot}
    </div>
    <div className="col">
      <a className="goods-title" onClick={e => events.onJumpItem(itemId, e)}>{title || itemName}</a>
      <div className="price">￥{((cprice || price) / 100).toFixed(2)}</div>
      <div className="labels">
        {label('月销量', (sale30day || salesVolume30) ?? '-')}
        {label('收藏', collect ?? '-')}
        {label('评价', commentCount ?? '-')}
      </div>
      <div className="shop-name" onClick={e => events.onJumpShop(shopId, e)}>
        {shopName}
      </div>
    </div>
    {deleteSlot ? <div className="delete-slot">{deleteSlot}</div> : null}
  </div>
}

export function ImageGallery({ images, onChange }) {
  const [visible, setVisible] = useState(false)
  const [tempValue, setTempValue] = useState([])
  const [params] = useState({ pageSize: 100, pageNo: 1 })
  const [materials, setMaterials] = useState([])
  const [sortValue, setSortValue] = useState({})
  const [currentIdeaMassId, setcurrentIdeaMassId] = useState(undefined)
  const [recentIdeaMasses, setRecentIdeaMasses] = useState([])
  const [insList, setInsList] = useState([])
  const [keyWords, setKeyWords] = useState('')
  const [count, setCount] = useState(0)
  const [doneCount, setDoneCount] = useState(0)
  const [isEmpty, setIsEmpty] = useState(false)
  const [start, setStart] = useState(0)
  const [isEnd, setIsEnd] = useState(false)
  const [loading, setLoading] = useState(false)
  const $sortWrapper = useRef()
  const $list = useRef()

  useEffect(() => {
    sort()
    fetchRecentIdeaMasses()
  }, [])

  useEffect(() => {
    setStart(0)
    fetchInsList(0)
  }, [keyWords])

  useEffect(() => {
    if (!sortValue.token) return
    const item = images.splice(sortValue.oldIndex, 1)
    images.splice(sortValue.newIndex, 0, ...item)
    onChange(images)
  }, [sortValue.token])

  const fetchRecentIdeaMasses = async () => {
    const res = await request.get('ins/inspiration/recently-used?limit=5&type=1')
    setRecentIdeaMasses(res)
  }
  const fetchMaterials = async (_count) => {
    const res = await request.get('/zhikuan/materials/materials-list', { params })
    setMaterials({ ...res, resultList: res.resultList?.map(m => ({ ...m, mainUrl: m.materialUrl })) })
    if (_count) {
      for (let i = 0; i < _count; i++) {
        events.onAddToTemp({ ...res.resultList[i], mainUrl: res.resultList[i].materialUrl })
      }
    }
  }
  const fetchInsList = async (_start) => {
    try {
      setLoading(true)
      const res = await request.spost(`/zhikuan/ins/inspiration/list-inspiration?start=${_start}&pageSize=20`, {
        _start,
        pageSize: 20,
        rankStatus: -2,
        queryType: 3,
        topFirstStatus: 1,
        keyWords,
      })
      _start === 0 ? setInsList(res.resultList) : setInsList(pre => ([...pre, ...res.resultList]))
      setStart(pre => pre + 20)
      setIsEnd(!res.resultList?.length)
      setIsEmpty(false)
      if (keyWords && _start === 0) {
        if (res.resultList.length) {
          setcurrentIdeaMassId(res.resultList[0].id)
        } else {
          setIsEmpty(true)
        }
      }
      setLoading(false)
    } catch (err) {
      console.error(err)
    }
  }
  const sort = () => {
    const container = $sortWrapper.current
    if (container.length === 0) {
      return false
    }
    const sortable = new Sortable(container, {
      draggable: '.meinian-image-gallery-image',
      mirror: {
        constrainDimensions: true
      },
    })
    sortable.on('sortable:sorted', ({ data }) => {
      setSortValue({ ...data, token: new Date().getTime() })
    })
  }
  const events = {
    onClickAdd() {
      fetchMaterials()
      fetchRecentIdeaMasses()
      if (images) {
        setTempValue([...images])
      }
      setcurrentIdeaMassId(undefined)
      setKeyWords(undefined)
      setIsEmpty(false)
      setVisible(true)
    },
    onClickDel(image, e) {
      e.stopPropagation()
      if (images.length < 2) {
        return message.warn('至少保留一张图片')
      }
      onChange(images.filter(m => m.mainUrl !== image.mainUrl))
    },
    onChangeMainImg(_images, image, e) {
      e.stopPropagation()
      const newImages = _images.filter(m => m.mainUrl !== image.mainUrl)
      newImages.unshift(image)
      onChange(newImages)
    },
    onUploadProgress(fileList) {
      setCount(fileList.length)
      setDoneCount(0)
      uploadCount = 0
    },
    async onUpload(url, fileName, files) {
      const model = { ...materials?.param, materialUrl: url, fileName }
      try {
        await request.post('/zhikuan/materials/add-materials', model)
        if (uploadCount + 1 === files.length) {
          await fetchMaterials(files.length)
        }
        setDoneCount(++uploadCount)
      } catch (error) {
        console.error(error)
      }
    },
    onAddToTemp(image) {
      if (tempValue.length >= MAX_SELECT_COUNT) {
        return
      }
      tempValue.push(image)
      setTempValue([...tempValue])
    },
    onDelTempValue(image, e) {
      e && e.stopPropagation()
      setTempValue(tempValue.filter(m => m.mainUrl !== image.mainUrl))
    },
    onClickImg(image) {
      if (tempValue.some(m => m?.mainUrl === image?.mainUrl)) {
        events.onDelTempValue(image)
        return
      }
      events.onAddToTemp(image)
    },
  }
  const onLoad = () => {
    if (isEnd) return
    fetchInsList(start)
  }
  const onChangeKey = (_keyWords) => {
    setKeyWords(_keyWords)
  }
  return <div className="meinian-image-gallery">
    {visible ? <GalleryModal
      visible={visible}
      setVisible={setVisible}
      setTempValue={setTempValue}
      images={images}
      onChange={onChange}
      tempValue={tempValue}
      $list={$list}
      onChangeKey={onChangeKey}
      keyWords={keyWords}
      setcurrentIdeaMassId={setcurrentIdeaMassId}
      currentIdeaMassId={currentIdeaMassId}
      recentIdeaMasses={recentIdeaMasses}
      insList={insList}
      onLoad={onLoad}
      isEnd={isEnd}
      loading={loading}
      isEmpty={isEmpty}
      events={events}
      count={count}
      doneCount={doneCount}
      materials={materials}
    /> : null}
    <div ref={$sortWrapper} className="images-wrapper">
      {((images?.length || 0) < MAX_SELECT_COUNT) && <AddBox title="添加图片" onClick={events.onClickAdd} className="add-img" />}
      {images?.map((m, index) => <Image
        src={ossImg(m.mainUrl, 300, 300)}
        className="meinian-image-gallery-image"
        key={m.mainUrl}
      >
        {index === 0 ? <MainTag /> : null}
        <DeleteButton iconType="m-jianshao_tianchong" onMouseDown={e => events.onClickDel(m, e)} />
        {index === 0 ? null : <SetMainImg onMouseDown={e => events.onChangeMainImg(images, m, e)} />}
      </Image>)}</div>
  </div>
}
